import { EnvironmentProviders, Provider, inject, provideAppInitializer } from '@angular/core';

import { Logger, WindowRef } from '@frontend/vanilla/core';

import { VIEW_TRANSITION_LOG_TAG as LOG_TAG } from '../view-transition.constants';
import { BrowserBackDetectionStrategy } from './strategies/browser-back-detection.strategy.model';
import { NavigationApiBackDetectionStrategy } from './strategies/navigation-api-back-detection.strategy';

export class BrowserBackDetectionService {
    private logger = inject(Logger);
    private windowRef = inject(WindowRef);
    private _strategy?: BrowserBackDetectionStrategy;

    get strategy() {
        return this._strategy;
    }

    init(): this {
        const isNavigationApiSupported = this.windowRef.nativeWindow.navigation;

        if (isNavigationApiSupported) {
            this.logger.info(`${LOG_TAG} Using Navigation Api strategy for browser back detection`);

            this._strategy = new NavigationApiBackDetectionStrategy().init();
        } else {
            this.logger.info(`${LOG_TAG} No strategy for browser back detection - browser back detection is disabled`);
        }

        return this;
    }
}

export const provideBrowserBackDetection = (type?: 'backdetection' | 'noop'): (Provider | EnvironmentProviders)[] => {
    if (type === 'noop') {
        return [];
    }

    return [
        BrowserBackDetectionService,
        provideAppInitializer(() => {
            const initializerFn = browserBackDetectionInitializer();
            return initializerFn();
        }),
    ];
};

const browserBackDetectionInitializer = (): VoidFunction => {
    inject(BrowserBackDetectionService).init();

    return () => {
        /** noop */
    };
};
